import { WorkingHours } from "@forwardflow/components/Campaign/WorkingHours";

const WorkingHoursPage = () => {
  return (
    <>
      <WorkingHours></WorkingHours>
    </>
  );
};
export default WorkingHoursPage;
